import { ChevronRight } from '@/src/assets/icons/ChevronRight'
import { mesaColorNames } from '@/src/common/theme'
import type { ComponentProps } from 'react'
import {
  type GestureResponderEvent,
  View,
  TouchableOpacity,
  type TextProps,
  Text,
  StyleSheet,
} from 'react-native'

interface ChevronPropsInterface extends Pick<ComponentProps<typeof TouchableOpacity>, 'disabled'> {
  name: string
  caption: string
  onPress?: (event: GestureResponderEvent) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  captionProps?: TextProps
}

export function Chevron({
  name,
  caption,
  onPress,
  captionProps,
  disabled = !onPress,
}: ChevronPropsInterface) {
  return (
    <TouchableOpacity style={chevronStyles.elementContainer} onPress={onPress} disabled={disabled}>
      <View style={chevronStyles.elementInfoContainer}>
        <View style={chevronStyles.elementNameContainer}>
          <Text style={chevronStyles.elementNameText}>{name}</Text>
        </View>
        <View>
          <Text {...captionProps} style={[chevronStyles.elementCaption, captionProps?.style]}>
            {caption}
          </Text>
        </View>
      </View>
      {onPress ? (
        <View style={chevronStyles.actionContainer}>
          <ChevronRight color={mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']} />
        </View>
      ) : null}
    </TouchableOpacity>
  )
}

const chevronStyles = StyleSheet.create({
  elementContainer: {
    paddingVertical: 10,
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
  },
  elementInfoContainer: {
    flex: 1,
  },
  elementNameContainer: {
    paddingVertical: 5,
  },
  elementNameText: {
    fontSize: 16,
    color: mesaColorNames['Greyscale/900 #152438'],
  },
  elementCaption: {
    fontSize: 14,
    color: mesaColorNames['Greyscale/600 #505D64'],
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
})
